<template>
    <a-entity
        :position-from-sky="position"
    >
        <a-image
            :width="linkspot.width"
            :height="linkspot.height"
            :src="linkspot.icon"
            class="clickable close_on_active"
            hover-effect-scale="scale: 1.25"
            @click="onClick"
            play-sound="audio: #audio-bop; events: click"
            :tooltip="linkspot.tooltip"
            :showline="linkspot.xyz"
        ></a-image>
    </a-entity>
</template>

<script>
export default {
    name: "LinkSpot",
    props: ['linkspot'],
    data: function () {
        return {
        }
    },
    computed: {
        position: function () {
            return {
                skyPosition: this.linkspot.xyz,
                distance: 5,
            }
        },
    },
    created: function () {
        const me = this;
    },
    methods: {
        onClick() {
            this.$parent.$parent.setPageId(this.linkspot.page_id);
        }
    }
}
</script>

<style scoped>

</style>